module.exports = __webpack_public_path__ + "static/img/vr03.afb45cbe.jpg";